import React from "react";
import {
  Box,
  Typography,
  Paper,
  Button,
  Alert,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import expressConfig from "src/config/express.json";
import { ChatbotConfig } from "./types";

interface InstallTabProps {
  botId: string;
  deploymentId?: string;
  config?: ChatbotConfig;
}

const InstallTab: React.FC<InstallTabProps> = ({ deploymentId }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const env =
    process.env.REACT_APP_NODE_ENV || process.env.NODE_ENV || "development";
  const config = (expressConfig as any)[env];
  const backendBaseUrl = `${config.graphql_domain}${
    config.port ? `:${config.port}` : ""
  }`;

  // For widgets
  const scriptCode = `<script
  src="${backendBaseUrl}/widget/v1/widget.js"
  data-widget-id="${deploymentId}"
  async
></script>`;

  const handleCopyCode = () => {
    navigator.clipboard.writeText(scriptCode);
  };

  if (!deploymentId) {
    return (
      <Box sx={{ p: 3 }}>
        <Alert severity="warning">
          Bot is not deployed yet. Please configure and save to generate the
          installation script.
        </Alert>
      </Box>
    );
  }

  return (
    <Box sx={{ p: { xs: 2, sm: 3 }, maxWidth: "100%", overflow: "hidden" }}>
      <Typography variant="h6" gutterBottom>
        Embed Code
      </Typography>
      <Typography variant="body2" color="textSecondary" gutterBottom>
        Copy and paste this code into your website's HTML, just before the
        closing &lt;/body&gt; tag.
      </Typography>

      <Paper
        sx={{
          p: { xs: 1.5, sm: 2 },
          bgcolor: "#1e1e1e",
          color: "#d4d4d4",
          fontFamily: "monospace",
          fontSize: { xs: "0.7rem", sm: "0.875rem" },
          overflowX: "auto",
          mt: 2,
          maxWidth: "100%",
        }}
      >
        <pre
          style={{
            margin: 0,
            whiteSpace: "pre-wrap",
            wordBreak: "break-all",
          }}
        >
          {scriptCode}
        </pre>
      </Paper>

      <Button
        variant="contained"
        onClick={handleCopyCode}
        fullWidth={isMobile}
        sx={{ mt: 2 }}
      >
        Copy Code
      </Button>

      <Box sx={{ mt: 4 }}>
        <Typography variant="h6" gutterBottom>
          Channel Integration
        </Typography>
        <Typography variant="body2" color="textSecondary" gutterBottom>
          This bot is configured to handle multiple channels automatically as
          they are connected.
        </Typography>
      </Box>
    </Box>
  );
};

export default InstallTab;
